import {getGlobalProperties} from "@/src/shared/helpers/getGlobalProperties";
import {ref} from "vue";

export default function useSessions() {
    const { $api } = getGlobalProperties()
    const loadingRecentSessions = ref(false)
    const recentSessions = ref([])

    if (!$api) {
        console.error("API instance is not available");
    }

    const getRecentSessions = () => {
        loadingRecentSessions.value = true;
        return $api.get('/api/chat/opponent-info/recent-chats')
            .then(res => {
                recentSessions.value = res.data;
                loadingRecentSessions.value = false;

            })
            .catch(error => {
                console.error(error);
                loadingRecentSessions.value = false;
            })
    }

    return {
        getRecentSessions, recentSessions
    };
}
